import { IPropertyDetailsResponse } from "@/src-refactor/modules/store/qrtk/services/realestate/responses/property-details.response";

export const prepareDetailPropertyImages = (
  data: IPropertyDetailsResponse
): string[] => {
  return data?.pictures?.map(image => image.pictures) || [];
};
